import { MapPin } from "lucide-react";
import { AREAS, BUSINESS } from "@/data/site";
import { PageHero } from "@/components/PageHero";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { CtaBanner } from "@/components/CtaBanner";

const RegionCard = ({ title, regions, tag }) => (
  <div className="rounded-3xl border border-slate-200 bg-white p-8 md:p-10">
    <div className="flex items-center gap-3">
      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-electric/10">
        <MapPin className="h-5 w-5 text-brand-electric" />
      </span>
      <div>
        <h3 className="font-display text-2xl font-semibold text-brand-blue">{title}</h3>
        <p className="text-sm text-slate-500">{tag}</p>
      </div>
    </div>
    <ul className="mt-7 grid gap-3 sm:grid-cols-2">
      {regions.map((r) => (
        <li key={r} className="flex items-center gap-3 rounded-xl border border-slate-100 bg-[#FAFAFA] px-4 py-3 text-[15px] text-brand-blue">
          <span className="h-1.5 w-1.5 rounded-full bg-brand-gold" /> {r}
        </li>
      ))}
    </ul>
  </div>
);

export default function AreasWeServe() {
  return (
    <>
      <PageHero
        label="Areas We Serve"
        title="Proudly servicing Victoria & New South Wales"
        subtitle="We provide electrical, air conditioning and heat pump hot water services across select regions in Victoria and NSW — and the surrounding communities."
        crumbs={[{ label: "Areas We Serve" }]}
      />

      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-8 lg:grid-cols-2">
            <Reveal><RegionCard title="Victoria" tag="Regional & metro coverage" regions={AREAS.vic} /></Reveal>
            <Reveal delay={0.1}><RegionCard title="New South Wales" tag="Sydney's north" regions={AREAS.nsw} /></Reveal>
          </div>
          <Reveal>
            <p className="mt-8 text-center text-sm text-slate-500">
              Not sure if we cover your area? <a href={BUSINESS.phoneHref} className="font-semibold text-brand-electric hover:underline">Give us a call</a> — we service these regions and surrounding communities.
            </p>
          </Reveal>
        </div>
      </section>

      <CtaBanner />
    </>
  );
}
